import { createStyles, Theme } from '@material-ui/core/styles';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    dateRangeContainer: {
      padding: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
    formControl: {
      minWidth: 200,
      marginRight: theme.spacing(2),
      marginBottom: theme.spacing(2),
      [theme.breakpoints.down('xs')]: {
        width: '100%',
        marginRight: 0,
      },
    },
    datePicker: {
      marginRight: theme.spacing(2),
      marginBottom: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        marginRight: 0,
      },
    },
    metricCard: {
      padding: theme.spacing(3),
      textAlign: 'center',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      minHeight: 140,
      borderRadius: theme.spacing(1),
      boxShadow: 'none',
      border: `1px solid ${theme.palette.divider}`,
      backgroundColor: theme.palette.background.paper,
      transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      '&:hover': {
        backgroundColor: theme.palette.background.default,
      },
    },
    chartContainer: {
      padding: theme.spacing(4),
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      borderRadius: theme.spacing(1),
      boxShadow: 'none',
      border: `1px solid ${theme.palette.divider}`,
      backgroundColor: theme.palette.background.paper,
      transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      '&:hover': {
        backgroundColor: theme.palette.background.default,
      },
      [theme.breakpoints.up('xl')]: {
        minHeight: 450,
        padding: theme.spacing(5),
      },
      [theme.breakpoints.down('md')]: {
        minHeight: 400,
      },
    },
    chartTitle: {
      marginBottom: theme.spacing(3),
      fontWeight: 600,
      color: theme.palette.text.primary,
      fontSize: '1.1rem',
      [theme.breakpoints.up('xl')]: {
        marginBottom: theme.spacing(4),
        fontSize: '1.3rem',
      },
    },
    chart: {
      position: 'relative',
      height: 350,
      width: '100%',
      flex: 1,
      [theme.breakpoints.up('xl')]: {
        height: 400,
      },
      [theme.breakpoints.down('md')]: {
        height: 300,
      },
    },
    pieChart: {
      position: 'relative',
      height: 350,
      width: '80%',
      display: 'flex',
      justifyContent: 'center',
      margin: '0 auto',
      [theme.breakpoints.up('xl')]: {
        height: 400,
      },
      [theme.breakpoints.down('md')]: {
        height: 300,
      },
    },
    marginBottom: {
      marginBottom: theme.spacing(4),
      [theme.breakpoints.up('xl')]: {
        marginBottom: theme.spacing(5),
      },
    },
    toggleButton: {
      fontSize: 16,
      fontWeight: 600,
    },
    tableContainer: {
      maxHeight: 400,
      overflow: 'auto',
      borderRadius: theme.spacing(1),
      border: `1px solid ${theme.palette.divider}`,
      backgroundColor: theme.palette.background.paper,
      '& .MuiTableHead-root': {
        '& .MuiTableCell-head': {
          backgroundColor: theme.palette.type === 'dark' ? '#2d3748' : '#f5f5f5',
          fontWeight: 600,
          position: 'sticky',
          top: 0,
          zIndex: 1,
          color: theme.palette.text.primary,
        },
      },
      '& .MuiTableBody-root': {
        '& .MuiTableRow-root:nth-of-type(even)': {
          backgroundColor: theme.palette.type === 'dark' ? '#1a202c' : '#fafafa',
        },
        '& .MuiTableRow-root:hover': {
          backgroundColor: theme.palette.action.hover,
        },
        '& .MuiTableCell-body': {
          color: theme.palette.text.primary,
          borderBottom: `1px solid ${theme.palette.divider}`,
        },
      },
    },
  });

export default styles;
